//@ts-nocheck
import React from 'react'
import { DefaultRootState, connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import createAction from 'loankeeper-common/helpers/createAction'

import { selectors as DCSelectors, actions as DCActions, constants as DCConstants } from '../../../DetailsContainer'

import Operations from './Operations'
import Transactions from './Transactions'

import { pages, actions, REDUCER_NAME } from './constants'

import { OperationTransactionsProps, OperationData } from '../../types.LoanDetails'

const getInstance = (state: DefaultRootState, ID: string) => state[REDUCER_NAME][ID] || {}
const getUI = (state: DefaultRootState, ID: string) => getInstance(state, ID).ui || {}

//@ts-ignore
@withRouter
//@ts-ignore
@connect(
  (state, { ID }: {ID: string}) => ({
    nominalFlag: getUI(state, ID).nominalFlag,
    activeOperationsFlag: getUI(state, ID).activeOperationsFlag,
    activePage: getUI(state, ID).activePage,
    loading: getUI(state, ID).fetching,
    operData: getInstance(state, ID).data,
    transactions: DCSelectors.getInfoPage(state, { type: 'Loan', ID, page: 'transactions' }),
  }),
  (dispatch, { ID, hash } : {ID: string, hash: string}) => ({
    initialize: (data: OperationData) => {
      dispatch(createAction(actions.INITIALIZE, { data }, { ID }))
    },

    changeNominalFlag: (nominalFlag: number, activeOperationsFlag: number) => {
      //@ts-ignore
      dispatch([
        createAction(actions.CHANGE_NOMINAL, { nominalFlag }, { ID }),
        createAction(actions.FETCH, { hash, nominalFlag, activeOperationsFlag, page: 'operations' }, { ID }),
      ])
    },

    changeActiveOperationsFlag: (activeOperationsFlag: number, nominalFlag: number) => {
      //@ts-ignore
      dispatch([
        createAction(
          actions.CHANGE_ACTIVE_OPERATIONS_FLAG,
          { activeOperationsFlag: Number(activeOperationsFlag) },
          { ID },
        ),
        createAction(actions.FETCH, { hash, nominalFlag, activeOperationsFlag, page: 'operations' }, { ID }),
      ])
    },

    switchPage: (page: string) => {
      dispatch(createAction(actions.SWITCH_PAGE, { page }, { ID }))
    },

    fetchTransactions: () => {
      dispatch(
        DCActions.fetchPage({
          type: 'Loan',
          ID,
          hash,
          page: 'transactions',
        }),
      )
    },
  }),
)
class OperationTransactions extends React.Component<OperationTransactionsProps> {
  state = {
    activePage: ''
  }

  componentDidMount() {
    const { operData, initialize, data } = this.props
    if (!operData) {
      initialize(data.operations)
    }

    const params = new URLSearchParams(this.props.location.search)
    const activePageQuery = params.get('activePage')

    if (activePageQuery === 'transactions') {
      this.switchPage('transactions')
    }
  }

  // TODO: move this to getDerivedStateFromProps
  componentDidUpdate(prevProps: OperationTransactionsProps) {
    if (!this.state.activePage || prevProps.ID !== this.props.ID) {
      if (prevProps.ID !== this.props.ID) {
        prevProps.switchPage(this.state.activePage)
      }

      const params = new URLSearchParams(prevProps.location.search)
      const activePageQuery = params.get('activePage')

      this.setState({
        activePage: activePageQuery || this.props.activePage,
      })
    }
  }

  switchPage = (activePage: string) => {
    if (activePage === 'transactions' && !this.props.transactions) {
      this.props.fetchTransactions()
    }

    this.setState({ activePage })

    const searchParams = new URLSearchParams(this.props.location.search)
    searchParams.set('activePage', activePage)

    this.props.history.push({
      pathname: this.props.location.pathname,
      search: searchParams.toString(),
    })
  }

  fetchOperations = () => {
    const { nominalFlag, activeOperationsFlag, ID, hash } = this.props
    return createAction(actions.FETCH, { hash, nominalFlag, activeOperationsFlag, page: 'operations' }, { ID })
  }

  render() {
    const {
      ID,
      hash,
      nominalFlag,
      activeOperationsFlag,
      loading,
      operData,
      changeNominalFlag,
      changeActiveOperationsFlag,
      transactions,
    } = this.props

    if (!operData) {
      return null
    }

    const { base } = this.props.data

    switch (this.state.activePage || pages.operations) {
      case pages.operations: {
        return (
          //@ts-ignore
          <Operations
            instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${ID}-Operations`}
            data={operData || this.props.data.operations}
            changeNominalFlag={changeNominalFlag}
            changeActiveOperationsFlag={changeActiveOperationsFlag}
            switchPage={this.switchPage}
            nominalFlag={nominalFlag}
            activeOperationsFlag={activeOperationsFlag}
            loading={loading}
            base={base}
            fetchOperations={this.fetchOperations}
          />
        )
      }

      default:
        return (
          <Transactions
            ID={ID}
            hash={hash}
            instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${ID}-Transactions`}
            switchPage={this.switchPage}
            data={transactions}
            base={base}
            fetchOperations={this.fetchOperations}
          />
        )
    }
  }
}

export default OperationTransactions
